<app-reports-header
	[report]="report"
	[(startDate)]="startDate"
	[(endDate)]="endDate"
	[(revenueCenter)]="revenueCenter"
	(reportRunChange)="checksGet()"
></app-reports-header>

<p-table
	#dt
	styleClass="p-datatable-responsive-demo"
	[value]="tableStatistic"
	[loading]="!tableStatistic"
	[globalFilterFields]="app.keys(tableStatistic)"
	[scrollable]="true"
	[rows]="100"
	scrollHeight="700px"
	[virtualScroll]="true"
	[virtualRowHeight]="40"
>
	<ng-template pTemplate="caption">
		<div class="table-header d-flex">
			<div class="flex-grow-1">
				<span class="p-float-label p-input-icon-left m-2 w-100">
					<i class="pi pi-search"></i>
					<input
						pInputText
						class="w-100"
						id="globalSearch"
						name="globalSearch"
						style="width: 100%"
						type="text"
						(input)="dt.filterGlobal($event.target.value, 'contains')"
					/>
					<label for="globalSearch">Search...</label>
				</span>
			</div>
		</div>
	</ng-template>
	<ng-template pTemplate="header">
		<tr>
			<th pSortableColumn="table">
				Table
				<p-sortIcon field="table"></p-sortIcon>
			</th>
			<th pSortableColumn="averageTurn">
				Turn Time
				<p-sortIcon field="averageTurn"></p-sortIcon>
			</th>
			<th pSortableColumn="averageGuest">
				PGA
				<p-sortIcon field="averageGuest"></p-sortIcon>
			</th>
			<th pSortableColumn="averageCheck">
				PCA
				<p-sortIcon field="averageCheck"></p-sortIcon>
			</th>
			<th>Checks</th>
		</tr>
	</ng-template>
	<ng-template let-rec pTemplate="body">
		<tr>
			<td>{{ rec.table }}</td>
			<td>{{ app.moment.duration(rec.averageTurn).locale("en").humanize() }}</td>
			<td>{{ rec.averageGuest | currency }}</td>
			<td>{{ rec.averageCheck | currency }}</td>
			<td>
				<div class="d-flex">
					<ng-container *ngFor="let chk of rec.checks">
						<span class="me-1">{{ chk.ID }}</span>
					</ng-container>
				</div>
			</td>
		</tr>
	</ng-template>
</p-table>
